import { render, staticRenderFns } from "./SectionControlFilters.vue?vue&type=template&id=4581e642&scoped=true"
import script from "./SectionControlFilters.vue?vue&type=script&lang=js"
export * from "./SectionControlFilters.vue?vue&type=script&lang=js"
import style0 from "./SectionControlFilters.vue?vue&type=style&index=0&id=4581e642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4581e642",
  null
  
)

export default component.exports